import {
  ladderResponseSchema,
  rankedProfileResponseSchema,
  type LadderResponse,
  type RankedProfileResponse,
} from '../../shared/api';
import { API_PATHS } from '../../shared/routes';
import { fetchJson } from './http';
import { PAGE_SIZE } from './results';

export function readRankedProfile(credential: string, signal?: AbortSignal): Promise<RankedProfileResponse> {
  return fetchJson(rankedProfileResponseSchema, API_PATHS.ranked, {
    credential,
    failure: 'Your rank is unavailable. Try again.',
    ...(signal ? { signal } : {}),
  });
}

export function readLadderPage(
  { offset, signal }: { offset: number; signal?: AbortSignal },
  credential?: string | null,
): Promise<LadderResponse> {
  return fetchJson(ladderResponseSchema, `${API_PATHS.ladder}?limit=${PAGE_SIZE}&offset=${offset}`, {
    credential: credential ?? null,
    failure: 'Ladder unavailable. Try again.',
    ...(signal ? { signal } : {}),
  });
}
